<template>
  <div class="tablelist">
    <div class="row align--center">
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
      <template slot="courseList" slot-scope="props">
        <ul class="listUL" v-for="itemdata of JSON.parse(props.rowData.Det_Courses)" :key="itemdata.id">
          <li>{{itemdata.CFPC_Name}}</li>
        </ul>
      </template>
      <template slot="status" slot-scope="props">
        <img class="imgdata ma-0" src="../../assets/images/user_check.png" width="20" alt="Activo" title="Activo" v-if="props.rowData.StaStatus === true"/>
        <img class="imgdata ma-0" src="../../assets/images/user_inactive.png" width="20" alt="Inactivo" title="Inactivo" v-else/>
      </template>
      <template slot="statusHistory" slot-scope="props">
        <img class="imgdata ma-0" src="../../assets/images/user_check.png" width="20" alt="Activo" title="Activo" v-if="props.rowData.IsHistoric === true"/>
        <img class="imgdata ma-0" src="../../assets/images/user_inactive.png" width="20" alt="Historico" title="Historico" v-else/>
      </template>
      <template slot="dateCretedIni" slot-scope="props">
        <div class="datime">{{valDatetime(props.rowData.DateCharactStart)}}</div>
      </template>
      <template slot="dateCretedFin" slot-scope="props">
        <div class="datime">{{valDatetime(props.rowData.DateCharactEnd)}}</div>
      </template>
      <template slot="dateCretedExe" slot-scope="props">
        <div class="datime">{{valDatetime(props.rowData.DatePersonCharact)}}</div>
      </template>
      <template slot="actions" slot-scope="props">
        <div v-for="item of fields[fields.length-1].actionRef" :key="item.id">
          <template v-if="item.action === 'show'">
            <router-link :to="'/admin/ReportCharactData/6/'+props.rowData.IdCharacterization"><img class="imgdata ma-0" :id="props.rowData.IdCharacterization" src="../../assets/images/detail.png" alt="Verificar" title="Verificar" width="20"/></router-link>
          </template>
        </div>
      </template>
      <template slot="viewHistory" slot-scope="props">
        <div v-for="item of fields[fields.length-1].actionRef" :key="item.id">
          <template v-if="item.action === 'show'">
            <router-link :to="'/admin/ReportCharactData/7/'+props.rowData.IdCharacterization"><img class="imgdata ma-0" :id="props.rowData.IdCharacterization" src="../../assets/images/DB_History.png" alt="Verificar" title="Verificar" width="20"/></router-link>
          </template>
        </div>
      </template>
      <template slot="history" slot-scope="props">
        <div v-for="item of fields[fields.length-1].actionRef" :key="item.id">
          <template v-if="item.action === 'show'">
            <img class="imgdata ma-0" :id="props.rowData.IdCharacterization" src="../../assets/images/detail.png" alt="Verificar" title="Verificar" width="20" @click="dataReg(props.rowData)"/>
          </template>
        </div>
      </template>
    </va-data-table>
    <div v-if="this.reportCaract !== ''" class="text-right">
      <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="exportExcel">
          <va-icon name="fa fa-download" size="60" /> Generar Reporte
      </button>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { debounce } from 'lodash'
import IberoHelpers from '@/store/helpers.js'

export default {
  data () {
    return {
      reportCaract: this.Report,
      term: null,
      perPage: '20',
      perPageOptions: ['4', '6', '10', '20'],
      StatusOptions: [
        {
          id: 1,
          description: 'Activo',
        },
        {
          id: 2,
          description: 'Inactivo',
        },
      ],
      StatusOptionsModel: '',
      users: this.InfoView,
      arrayReport: [],
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
    Report: String,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      if (((!this.term) || (this.term.length < 1)) && (!this.StatusOptionsModel.id)) {
        return this.users
      }
      return this.users.filter(item => {
        if (this.term && this.term.length >= 1) {
          return item.idBanner.toLowerCase().startsWith(this.term.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        switch (this.StatusOptionsModel.id) {
          case 1:
            return item.staStatus === true
          case 2:
            return item.staStatus === false
          default:
            return item
        }
      })
    },
  },
  methods: {
    exportExcel: function () {
      debugger
      if (this.filteredData.length >= 1) {
        let loader = this.$loading.show()
        this.arrayReport.length = 0
        let listReg = 1
        for (var i = 0; i < this.filteredData.length; i++) {
          var newObject = {}
          newObject['#'] = listReg
          for (var j = 0; j < this.HeadTable.length; j++) {
            newObject[this.HeadTable[j].title] = this.filteredData[i][this.HeadTable[j].name]
          }
          listReg++
          this.arrayReport.push(newObject)
        }
        debugger
        var dateRef = new Date()
        var month = '' + (dateRef.getMonth() + 1)
        var day = '' + dateRef.getDate()
        if (month.length < 2) { month = '0' + month }
        if (day.length < 2) { day = '0' + day }

        const filename = 'ConsenInformado_' + day + month + dateRef.getFullYear()

        // const filename = this.reportCaract.replace(/[&/\\ #,+()$~%.'":*?<>{}]/g, '') + '_' + day + month + dateRef.getFullYear();

        let data = XLSX.utils.json_to_sheet(this.arrayReport)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
        loader.hide()
      }
    },
    valDate (datime) {
      return IberoHelpers.dataObjDate(datime)
    },
    valDatetime (datime) {
      return IberoHelpers.dataTimeObjDate(datime)
    },
    dataReg (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}

ul.listUL {
    width: 300px !important;
  list-style-type: square;
}

.datime{
  width: 150px !important;
}
</style>
